import { Link } from 'react-router-dom';
import MainSidebar from 'src/app/components/Sidebar';
import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';

export default function QuestionBookSidebar(props) {
  const { steps, currentStep, setCurrentStep, edit } = props;

  return (
    <MainSidebar hasBrand={false}>
      <nav className="notebook-sidebar__nav">
        <Link
          to="/avaliacoes/apostilas"
          className="filter-bar__back"
        >
          <div className="card__icon-wrapper">
            <FiChevronLeft />
          </div>
          <span className="filter-back__back-container">
            <span className="filter-bar__title">Apostila</span>
          </span>
        </Link>

        <ul className="step-by-step-nav">
          {steps.map((step, i) => {
            const index = i + 1;
            return (
              <li
                className={`step-by-step-nav__item ${index === currentStep ? 'active' : ''} ${currentStep > index ? 'step-by-step-nav__item--completed' : ''}`}
                onClick={() => edit && setCurrentStep(index)}
                key={i}
              >
                <Link
                  to={edit ? `/apostilas/criar/${step.route}` : ''}
                  className="step-by-step-nav__link"
                  style={{ cursor: edit ? 'pointer' : 'default' }}
                >
                  {step.text}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </MainSidebar>
  );
}
